var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ValidationObserver",
    { ref: "form", attrs: { slim: "" } },
    [
      _c(
        "inline-confirmation-dialog",
        {
          attrs: {
            value: _vm.showDialog,
            disabled: !_vm.inputs.chargeAccountIfNeeded || _vm.submitting,
            submitting: _vm.submitting,
            "close-on-confirm": false
          },
          on: {
            confirm: _vm.onConfirmed,
            input: function($event) {
              _vm.showDialog = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [
                  _vm.needsGrow
                    ? _c("span", [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t("NUMBER_POOL_CONFIRM_ALLOCATION_TITLE")
                            ) +
                            "\n      "
                        )
                      ])
                    : _c("span", [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t("NUMBER_POOL_CONFIRM_DEALLOCATION_TITLE")
                            ) +
                            "\n      "
                        )
                      ])
                ]
              },
              proxy: true
            },
            {
              key: "dialog",
              fn: function() {
                return [
                  _c("div", { staticClass: "form-horizontal" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "checkbox" }, [
                        _vm.needsGrow
                          ? _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.inputs.chargeAccountIfNeeded,
                                    expression: "inputs.chargeAccountIfNeeded"
                                  }
                                ],
                                staticClass: "m-t-2",
                                attrs: {
                                  type: "checkbox",
                                  name: "chargeAccountIfNeeded"
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.inputs.chargeAccountIfNeeded
                                  )
                                    ? _vm._i(
                                        _vm.inputs.chargeAccountIfNeeded,
                                        null
                                      ) > -1
                                    : _vm.inputs.chargeAccountIfNeeded
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.inputs.chargeAccountIfNeeded,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.inputs,
                                            "chargeAccountIfNeeded",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.inputs,
                                            "chargeAccountIfNeeded",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.inputs,
                                        "chargeAccountIfNeeded",
                                        $$c
                                      )
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "NUMBER_POOL_CONFIRM_ALLOCATION_RECHARGE_TEXT",
                                        {
                                          countNumbers: _vm.countNumbers,
                                          numberText: _vm.$tc(
                                            "NUMBER",
                                            _vm.countNumbers
                                          )
                                        }
                                      )
                                    ) +
                                    "\n              "
                                )
                              ])
                            ])
                          : _vm.needsShrink
                          ? _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.inputs.keepNumbers,
                                    expression: "inputs.keepNumbers"
                                  }
                                ],
                                staticClass: "m-t-2",
                                attrs: {
                                  type: "checkbox",
                                  name: "keepNumbers"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.inputs.keepNumbers)
                                    ? _vm._i(_vm.inputs.keepNumbers, null) > -1
                                    : _vm.inputs.keepNumbers
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.inputs.keepNumbers,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.inputs,
                                            "keepNumbers",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.inputs,
                                            "keepNumbers",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.inputs, "keepNumbers", $$c)
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t(
                                        "NUMBER_POOL_CONFIRM_DEALLOCATION_KEEP_NUMBERS_TEXT"
                                      )
                                    ) +
                                    "\n              "
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ])
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "form",
            {
              staticClass: "form-horizontal",
              attrs: { name: "vm.numberPoolForm", novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.onSubmit.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "fieldset",
                [
                  !_vm.config.EDIT_MODE
                    ? _c(
                        "Field",
                        {
                          attrs: {
                            label: _vm.$t("NUMBER_POOL_COUNTRY"),
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("NUMBER_POOL_COUNTRY_TT")
                          }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "element" }, slot: "element" },
                            [
                              _c("ValidationProvider", {
                                ref: "country",
                                attrs: { rules: "required", slim: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ classes }) {
                                        return [
                                          _c("div", { class: classes }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-sm-4 col-md-3"
                                              },
                                              [
                                                _c("country-selector", {
                                                  attrs: {
                                                    full: true,
                                                    value: _vm.inputs.country,
                                                    "available-countries":
                                                      _vm.availableCountries,
                                                    name: "country",
                                                    required: "",
                                                    placeholder: _vm.$t(
                                                      "NUMBER_POOL_COUNTRY_DEFAULT"
                                                    )
                                                  },
                                                  on: {
                                                    change: _vm.onChangeCountry
                                                  },
                                                  model: {
                                                    value: _vm.inputs.country,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.inputs,
                                                        "country",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "inputs.country"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(_vm.$t("REQUIRED")) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3542025362
                                )
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.inputs.country || _vm.config.EDIT_MODE
                    ? [
                        _c(
                          "Field",
                          {
                            attrs: {
                              label: _vm.$t("NUMBER_POOL_NAME"),
                              "has-tooltip": true,
                              "tooltip-text": _vm.$t("NUMBER_POOL_NAME_TT")
                            }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "element" }, slot: "element" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-4 col-md-3"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.inputs.name,
                                                        expression:
                                                          "inputs.name"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      name: "numberPoolName",
                                                      required: "",
                                                      placeholder: _vm.$t(
                                                        "NUMBER_POOL_NAME_DEFAULT"
                                                      ),
                                                      "data-testid":
                                                        "pool-name-input"
                                                    },
                                                    domProps: {
                                                      value: _vm.inputs.name
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.inputs,
                                                          "name",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t("REQUIRED")
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3789498970
                                  )
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "Field",
                          {
                            attrs: {
                              label: _vm.$t("NUMBER_POOL_LOCK"),
                              "has-tooltip": true,
                              "tooltip-text": _vm.$t("NUMBER_POOL_LOCK_TT")
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "element" },
                              [
                                _c(
                                  "ValidationProvider",
                                  { attrs: { slim: "" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-3 col-sm-2 col-lg-1"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.inputs.closedBrowserDelay,
                                              expression:
                                                "inputs.closedBrowserDelay"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            placeholder: "30",
                                            type: "number",
                                            name: "lease",
                                            "data-testid": "pool-lease-input"
                                          },
                                          domProps: {
                                            value: _vm.inputs.closedBrowserDelay
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.inputs,
                                                "closedBrowserDelay",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "Field",
                          {
                            attrs: {
                              label: _vm.$t("NUMBER_POOL_MAX_LOCK"),
                              "has-tooltip": true,
                              "tooltip-text": _vm.$t("NUMBER_POOL_MAX_LOCK_TT")
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "element" },
                              [
                                _c(
                                  "ValidationProvider",
                                  { attrs: { slim: "" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-3 col-sm-2 col-lg-1"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.inputs.idleLimit,
                                              expression: "inputs.idleLimit"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            placeholder: "300",
                                            type: "number",
                                            name: "maxLease",
                                            "data-testid":
                                              "pool-max-lease-input"
                                          },
                                          domProps: {
                                            value: _vm.inputs.idleLimit
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.inputs,
                                                "idleLimit",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "Field",
                          {
                            attrs: {
                              label: _vm.$t("NUMBER_POOL_ALLOCATION"),
                              "has-tooltip": true,
                              "tooltip-text": _vm.$t(
                                "NUMBER_POOL_ALLOCATION_TT"
                              )
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "element" },
                              [
                                _c("ValidationProvider", {
                                  ref: "poolSize",
                                  attrs: { rules: _vm.poolSizeRules, slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-3 col-sm-2 col-lg-1"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName:
                                                          "v-model.number",
                                                        value:
                                                          _vm.inputs.poolSize,
                                                        expression:
                                                          "inputs.poolSize",
                                                        modifiers: {
                                                          number: true
                                                        }
                                                      }
                                                    ],
                                                    ref: "poolSizeInput",
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "number",
                                                      name: "allocate",
                                                      disabled:
                                                        _vm.disablePoolSize,
                                                      "data-testid":
                                                        "pool-allocate-input"
                                                    },
                                                    domProps: {
                                                      value: _vm.inputs.poolSize
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.inputs,
                                                          "poolSize",
                                                          _vm._n(
                                                            $event.target.value
                                                          )
                                                        )
                                                      },
                                                      blur: function($event) {
                                                        return _vm.$forceUpdate()
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.poolSizeErrorMessage
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1980787028
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.disablePoolSize
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 col-sm-9 col-md-6 col-lg-4 col-sm-offset-3"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "bs-callout bs-callout-sm bs-callout-warning m-t-0 m-b-5"
                                  },
                                  [
                                    _vm.isAllocatingNumbers
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "NUMBER_POOLS_ALLOCATING_MESSAGE"
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      : _c("i18n", {
                                          attrs: {
                                            path:
                                              "NUMBER_POOLS_RESTRICTED_COUNTRY_MESSAGE",
                                            tag: "span"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "link",
                                                fn: function() {
                                                  return [
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "text-underline",
                                                        attrs: {
                                                          href:
                                                            "https://support.ringba.com/en-us/article/number-pools-7wumsp/",
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "NUMBER_POOLS_RESTRICTED_COUNTRY_MESSAGE_LINK"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            false,
                                            4221572950
                                          )
                                        })
                                  ],
                                  2
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _vm.config.hasLocalNumbers &&
                            _vm.config.hasTollFreeNumbers
                              ? _c(
                                  "Field",
                                  {
                                    attrs: {
                                      label: _vm.$t("NUMBER_POOL_NUMBER_TYPE"),
                                      "has-tooltip": true,
                                      "tooltip-text": _vm.$t(
                                        "NUMBER_POOL_NUMBER_TYPE_TT"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "template",
                                      { slot: "element" },
                                      [
                                        _c("ValidationProvider", {
                                          ref: "numberType",
                                          attrs: {
                                            rules: "required",
                                            slim: ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ classes }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { class: classes },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-sm-4 col-md-3"
                                                          },
                                                          [
                                                            _c("input", {
                                                              attrs: {
                                                                type: "hidden",
                                                                name:
                                                                  "numberType"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.inputs
                                                                    .isTollFree
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "MultipleToggle",
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    _vm.inputs
                                                                      .isTollFree,
                                                                  options:
                                                                    _vm.options
                                                                      .numberType
                                                                },
                                                                on: {
                                                                  change: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.inputs.isTollFree =
                                                                      $event.value
                                                                  }
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c("label", {
                                                          directives: [
                                                            {
                                                              name: "t",
                                                              rawName: "v-t",
                                                              value: "REQUIRED",
                                                              expression:
                                                                "'REQUIRED'"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            2754968526
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.config.canSearchByRegion
                              ? _c(
                                  "Field",
                                  {
                                    attrs: {
                                      label: _vm.$t("NUMBER_POOL_AREA_CODE"),
                                      "has-tooltip": true,
                                      "tooltip-text": _vm.$t(
                                        "NUMBER_POOL_AREA_CODE_TT"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "template",
                                      { slot: "element" },
                                      [
                                        _c("ValidationProvider", {
                                          ref: "prefix",
                                          attrs: { rules: "no800", slim: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({
                                                  errors,
                                                  classes
                                                }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { class: classes },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-sm-4 col-md-2"
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model.number",
                                                                  value:
                                                                    _vm.inputs
                                                                      .prefix,
                                                                  expression:
                                                                    "inputs.prefix",
                                                                  modifiers: {
                                                                    number: true
                                                                  }
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                placeholder:
                                                                  "Optional",
                                                                type: "text",
                                                                name: "prefix",
                                                                autocomplete:
                                                                  "off"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.inputs
                                                                    .prefix
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  )
                                                                    return
                                                                  _vm.$set(
                                                                    _vm.inputs,
                                                                    "prefix",
                                                                    _vm._n(
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  )
                                                                },
                                                                blur: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.$forceUpdate()
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            errors.length > 0
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                        " +
                                                                        _vm._s(
                                                                          errors[0]
                                                                        ) +
                                                                        "\n                      "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            159902238
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-sm-9 col-md-9 col-md-offset-3 col-sm-offset-3 m-t-40"
                      },
                      [
                        _c(
                          "PrimaryButton",
                          {
                            attrs: {
                              size: "sm",
                              type: "submit",
                              "show-loader-on-form": _vm.submitting,
                              "data-testid": "pool-save-btn"
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("SAVE")) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("button", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CANCEL",
                              expression: "'CANCEL'"
                            }
                          ],
                          staticClass: "btn btn-sm btn-danger m-l-15",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.$emit(
                                "cancel",
                                $event,
                                _vm.EDIT_MODE ? _vm.value : undefined
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ],
                2
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }